import React, { createContext, useEffect, useState, useMemo } from "react";
import { globalHistory } from "@reach/router";
import * as styles from "~styles/disableScroll.module.scss";

export const AppContext = createContext({});

const AppProvider = ({ children }) => {
  const [pathname, setPathname] = useState(null);
  const [primaryColor, setPrimaryColor] = useState(`var(--color-sick-lime)`);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [globalSettings, setGlobalSettings] = useState();
  const [loading, setLoading] = useState(false);
  const [judgeMeLoaded, setJudgeMeLoaded] = useState(false);
  const [
    lastScrollYBeforeDisablingScroll,
    setLastScrollYBeforeDisablingScroll
  ] = useState(0);

  const scrollToUrlHash = (hash) => {
    setTimeout(() => {
      const hashString = hash.replace(`#`, ``);

      const element = document.getElementById(hashString);
      if (!element) return;

      const elementDistanceFromTop = element.getBoundingClientRect().top;
      const scrollY = document.documentElement.scrollTop;
      const offsetPosition = elementDistanceFromTop + scrollY - 52; // header height

      window.scrollTo({
        top: offsetPosition,
        behavior: `smooth`
      });
    }, 1000);
  };

  useEffect(() => {
    if (typeof window !== `undefined` && window?.location) {
      const { hash, pathname: windowPathname } = window.location;

      if (hash) {
        scrollToUrlHash(hash);
      }
      setPathname(windowPathname);
    }

    return globalHistory.listen(({ location }) => {
      const { hash, pathname: windowPathname } = location;

      if (hash) {
        scrollToUrlHash(hash);
      }

      setPathname(windowPathname);
    });
  }, []);

  // Close cart on navigation
  useEffect(() => {
    setIsCartOpen(false);
  }, [pathname]);

  // Disable page scroll
  useEffect(() => {
    if (isCartOpen || isMobileMenuOpen) {
      const scrollY = document.documentElement.scrollTop;
      setLastScrollYBeforeDisablingScroll(scrollY);
      document.body.style.top = `-${scrollY}px`;
      document.body.classList.add(styles.disableScroll);
    } else {
      document.body.style.top = `initial`;
      document.body.classList.remove(styles.disableScroll);
      document.documentElement.scrollTop = lastScrollYBeforeDisablingScroll;
      document.body.scrollTop = lastScrollYBeforeDisablingScroll;
    }
  }, [isCartOpen, isMobileMenuOpen]);

  const memoisedContextValues = useMemo(() => ({
    pathname,
    primaryColor,
    setPrimaryColor,
    isCartOpen,
    setIsCartOpen,
    globalSettings,
    setGlobalSettings,
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    loading,
    setLoading,
    judgeMeLoaded,
    setJudgeMeLoaded
  }));

  return (
    <AppContext.Provider value={memoisedContextValues}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
